/**
 * Trip Purge Type Enum
 *
 * Defines the types of trip cancellation/purge operations available.
 * - PARTIAL: Partial purge - cancels only specific items from the trip
 * - TOTAL: Total purge - cancels the entire trip
 */
export enum TripPurgeTypeEnum {
  PARTIAL = "PARTIAL", // Purga parcial del viaje
  TOTAL = "TOTAL"      // Purga total del viaje
}
